import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {Range} from "@/modules/redactor/models/utils/Range";

export class RarityConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(RarityConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(RarityConfig, v);
            }
        );
    }

    constructor() {
        super();

        this._amount = 0;
        this._percent = 0;
        this._range = new Range();
        this._strict = false;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    get percent() {
        return this._percent;
    }

    set percent(value) {
        this._percent = value;
    }

    get strict() {
        return this._strict;
    }

    set strict(value) {
        this._strict = value;
    }

    get range() {
        return this._range;
    }

    set range(value) {
        this._range = value;
    }


    valid() {
        if (!Number.isInteger(this.amount) || this.amount < 0) {
            return false;
        }

        if (!Number.isInteger(this.percent) || this.percent <= 0 || this.percent > 100) {
            return false;
        }

        if (!this.range && !this.range.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return this.percent === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RarityConfig());
        } else if (target instanceof RarityConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RarityConfig, {
    _strict: alias("strict", Schema.primitive()),
    _amount: alias("amount", Schema.primitive()),
    _range: alias("range", Range.schema()),
    _percent: alias("percent", Schema.primitive())
});